import { Field, InputType, ObjectType } from 'type-graphql'

import { modelOptions, Prop } from '@typegoose/typegoose'
import type { CustomerTypeEnum } from './CustomerTypeEnum'
import { BillToUps } from './BillToUps'
import { User } from '../user/User'

@ObjectType('Customer')
@InputType('CustomerInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'users' } }) //we need to define the collection name here, as the users, because it will use that collection
export class Customer extends User {
  @Field(() => String)
  @Prop({ type: String })
  customerType: CustomerTypeEnum

  @Field(() => BillToUps)
  @Prop({ type: BillToUps })
  ups: BillToUps

  @Field(() => String)
  @Prop({ type: String })
  discount: string

  @Field(() => String)
  @Prop({ type: String })
  paymentTerms: string

  // Set when a customer is auto-created from an inbound email, and it carries two meanings. The email is
  // authenticated at the Mailgun boundary but the display-name (used as the name) is not, so the record is
  // flagged for agent verification. It also marks a customer not yet sent its sign-in email: the first order
  // created for the customer sends that email, then unsets the flag.
  // Absent on legacy / normally-created customers and once cleared (treated as verified) — no DB default keeps
  // existing rows untouched.
  @Field(() => Boolean, { nullable: true })
  @Prop({ type: Boolean })
  isUnverified?: boolean
}
